import "gantt-task-react/dist/index.css"

import React from "react"
import { ViewMode } from "gantt-task-react"

export const ViewSwitcher = ({ onViewModeChange, onViewListChange, isChecked }) => {
    return (
        <div className='ViewContainer p-2 text-end'>
            <div className="btn-toolbar justify-content-end" role="toolbar" aria-label="Toolbar with button groups">
                <div className="btn-group btn-group-sm me-2" role="group" aria-label="First group">
                    <button type="button" className="btn btn-primary" onClick={() => onViewModeChange(ViewMode.Hour)}>
                        Hora
                    </button>
                    <button type="button" className="btn btn-primary" onClick={() => onViewModeChange(ViewMode.QuarterDay)}>
                        Cuarto del Día
                    </button>
                    <button type="button" className="btn btn-primary" onClick={() => onViewModeChange(ViewMode.HalfDay)}>
                        Medio Día
                    </button>
                    <button type="button" className="btn btn-primary" onClick={() => onViewModeChange(ViewMode.Day)}>
                        Día
                    </button>
                    <button type="button" className="btn btn-primary" onClick={() => onViewModeChange(ViewMode.Week)}>
                        Semana
                    </button>
                    <button type="button" className="btn btn-primary" onClick={() => onViewModeChange(ViewMode.Month)}>
                        Mes
                    </button>
                </div>
                <div className="btn-group me-2" role="group" aria-label="Second group">
                    <button
                        type="button"
                        className={`btn btn-outline-primary btn-sm custom-toggle ${isChecked ? 'active' : ''}`}
                        onClick={() => onViewListChange(!isChecked)}
                    >
                        <span className="icon-on">Mostrar Lista de Actividades</span>
                        <span className="icon-off">Ocultar Lista de Actividades</span>
                    </button>
                </div>
            </div>
        </div>
    )
}
